<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.order" clearable placeholder="单号/客户" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.product" clearable placeholder="存货编码/名称/规格" />
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
          </el-button-group>
        </el-form-item>
        <el-popover>
          <el-button slot="reference" size="small" type="text">
            更多查询
            <i class="el-icon-arrow-down"></i>
          </el-button>
          <el-form-item label="出库时段">
            <el-date-picker size="small" v-model="queryParams.datespan" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="部门/业务员/分类">
            <el-input v-model="queryParams.sales" clearable />
          </el-form-item>
          <el-form-item label="备注关键字">
            <el-input v-model="queryParams.remarks" clearable />
          </el-form-item>
        </el-popover>
      </el-form>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" :span-method="objectSpanMethod" border height="100%">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="出库单号" min-width="120" align="center">
        <el-tooltip slot-scope="{ row }" placement="right">
          <div slot="content" class="tppltip_content">
            <p><label>销售：</label>{{ row.Department }} {{ row.Salesman }} {{ row.Type }}</p>
            <p v-if="row.Remarks"><label>备注：</label>{{ row.Remarks }}</p>
          </div>
          <el-link type="primary">{{ row.OutboundCode }}</el-link>
        </el-tooltip>
      </el-table-column>
      <el-table-column prop="Customer" label="客户名称" min-width="180" />
      <el-table-column label="出库日期" min-width="100" align="center">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.Publish) }}
        </template>
      </el-table-column>
      <el-table-column label="库存编码" align="center" min-width="100">
        <el-link slot-scope="{ row }" type="primary" @click="$router.push({ name: 'a137ea3f52d84685b74168439cf660c9', params: { code: row.Code } })">{{ row.Code }}</el-link>
      </el-table-column>
      <el-table-column prop="Name" label="品名" min-width="120" show-overflow-tooltip />
      <el-table-column label="规格" min-width="200">
        <p slot-scope="{ row }" class="describe">{{ row.Spec }}</p>
      </el-table-column>
      <el-table-column label="数量" min-width="100" align="center">
        <template slot-scope="{ row }">{{ row.Quantity }}{{ row.Unit }}</template>
      </el-table-column>
      <el-table-column label="单价" align="center" min-width="100">
        <span slot-scope="{ row }" class="text-price text-danger">{{ row.Price }}</span>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-button-group>
        <el-button v-action="'/api/ProductManage/Outbound/Delete'" size="small" type="danger" icon="el-icon-delete" @click="onDelete">删除</el-button>
        <el-button v-action="'/api/ProductManage/Outbound/Import'" size="small" type="primary" icon="el-icon-upload2" @click="importData">导入</el-button>
      </el-button-group>
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onPager" />
    </div>
  </full-container>
</template>

<script>
import importpage from './import.vue'
export default {
  data () {
    return {
      loading: false,
      datalist: [],
      total: 0,
      queryParams: {
        index: 1,
        size: 30,
        ...this.$route.params
      },
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    resetForm () {
      this.queryParams = { index: 1, size: 30 }
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.product.outbound.list(this.queryParams).then((res) => {
        let items = []
        res.Items.forEach(i => {
          i.Items.forEach(row => {
            items.push({ ...i, ...row })
          })
        })
        res.Items = items
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //合并行
    objectSpanMethod ({ row, columnIndex }) {
      if (columnIndex < 4) {
        if (row.Id === row.Items[0].Id) {
          return {
            rowspan: row.Items.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    //删除选中项
    onDelete () {
      var ids = this.$refs.tb.selection.map((x) => x.OutboundCode)
      if (ids.length == 0) {
        this.$alert("请至少勾选一项要删除的数据", "提示", {
          center: true,
        })
        return
      }
      this.$confirm("此操作将永久删除选中的数据, 是否继续?", "提示", {
        center: true,
      }).then(() => {
        this.$apis.product.outbound.delete(ids).then((res) => {
          this.loadData()
          this.$message({
            message: res || "删除成功！",
            type: "success",
          })
        })
      }).catch(e => {
        console.log(e)
      })
    },
    //导入数据
    importData () {
      this.$layer.iframe({
        title: '导入数据',
        area: ['1000px', '800px'],
        content: {
          content: importpage,
          parent: this,
          data: {
            callback: () => {
              this.loadData()
            }
          }
        }
      })
    }
  }
}
</script>


<style lang="scss" scoped>
.tppltip_content {
  max-width: 400px;
  p {
    white-space: pre-wrap;
    display: flex;
    label {
      width: 60px;
      flex-shrink: 0;
    }
  }
  p + p {
    margin-top: 10px;
  }
}
</style>